import React, { useState, useEffect } from 'react';

function Captcha({ onValidate, resetTrigger }) {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState('');

  // Generate new captcha
  const generateCaptcha = () => {
    const n1 = Math.floor(Math.random() * 10) + 1;
    const n2 = Math.floor(Math.random() * 10) + 1;
    setNum1(n1);
    setNum2(n2);
    setUserAnswer('');
    setIsValid(false);
    setError('');
    onValidate(false);
  };

  // Initialize captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Reset captcha when resetTrigger changes
  useEffect(() => {
    if (resetTrigger) {
      generateCaptcha();
    }
  }, [resetTrigger]);

  // Validate answer
  const handleAnswerChange = (e) => {
    const answer = e.target.value;
    setUserAnswer(answer);
    setError('');

    if (answer === '') {
      setIsValid(false);
      onValidate(false);
      return;
    }

    const correctAnswer = num1 + num2;
    const userAnswerNum = parseInt(answer, 10);

    if (userAnswerNum === correctAnswer) {
      setIsValid(true);
      setError('');
      onValidate(true);
    } else {
      setIsValid(false);
      onValidate(false);
      if (answer.length > 0) {
        setError('Incorrect answer. Please try again.');
      }
    }
  };

  return (
    <div className="form-group">
      <label style={{ 
        display: 'block', 
        marginBottom: '10px', 
        fontWeight: '500',
        color: '#333'
      }}>
        Security Verification <span style={{ color: 'red' }}>*</span>
      </label>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '15px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '12px 15px',
          backgroundColor: '#f8f9fa',
          borderRadius: '5px',
          border: '1px solid #dee2e6',
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#495057',
          minWidth: '120px',
          justifyContent: 'center'
        }}>
          <span>{num1}</span>
          <span>+</span>
          <span>{num2}</span>
          <span>=</span>
        </div>
        <input
          type="number"
          value={userAnswer}
          onChange={handleAnswerChange}
          placeholder="Enter answer"
          className="form-control"
          style={{
            width: '120px',
            display: 'inline-block',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: '500'
          }}
          required
        />
        <button
          type="button"
          onClick={generateCaptcha}
          style={{
            padding: '8px 15px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
          title="Generate new captcha"
        >
          <i className="fas fa-sync-alt"></i> New
        </button>
      </div>
      {error && (
        <div style={{
          color: '#dc3545',
          fontSize: '14px',
          marginTop: '8px'
        }}>
          {error}
        </div>
      )}
      {isValid && userAnswer && (
        <div style={{
          color: '#28a745',
          fontSize: '14px',
          marginTop: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}>
          <i className="fas fa-check-circle"></i> Verification successful
        </div>
      )}
    </div>
  );
}

export default Captcha;

